import { createSelector } from 'reselect';

import { ClientComplianceReview, ComplianceNotesMap, ComplianceQuestion } from 'data/models/Compliance';
import { RootState } from 'data/store';

export const selectComplianceSelectedCheckslist = (state: RootState): ComplianceQuestion[] => {
  const checklist = state.compliance.selectedChecklist;
  if (checklist) {
    return checklist;
  }
  return [];
};

export const selectComplianceSelectedCheckslistNotes = (state: RootState): ComplianceNotesMap | undefined => {
  return state.compliance.SelectedChecklistNotes;
};

export const selectComplianceSelectedChecklist = createSelector(selectComplianceSelectedCheckslist, (checklist: ComplianceQuestion[] | undefined) => {
  return checklist;
});

export const selectComplianceSelectedChecklistNotes = createSelector(
  selectComplianceSelectedCheckslistNotes,
  (checklistNotes: ComplianceNotesMap | undefined) => {
    return checklistNotes;
  },
);

export const selectClientsComplianceReview = (state: RootState): ClientComplianceReview[] => {
  return state.compliance.clientsComplianceReview;
};
export const selectComplianceAssignees = (state: RootState): string[] => {
  return state.compliance.complianceAssignees;
};

export const selectClientComplianceReview = (state: RootState): ClientComplianceReview | undefined => {
  return state.compliance.selectedClientComplianceReview;
};

export const selectComplianceIsLoading = (state: RootState): boolean => {
  return state.compliance.isLoading;
};
